export class SamlAuthRequiredError extends Error {
  idCompany: string
  companyName: string

  constructor(idCompany: string, companyName: string) {
    super('SAML authentication required')
    this.name = 'SamlAuthRequiredError'
    this.idCompany = idCompany
    this.companyName = companyName
  }
}
